// const getTextItems = () => {
// 	return [
//     {resellerId: 1, route: "home", section: "leadTitle", value: "Gadget Claims"},
//     {resellerId: 1, route: "home", section: "leadText", value: "You can make a claim and check on the progress of an existing claim by choosing from the options below."},
//     {resellerId: null, route: "policyLookup", section: "title", value: "Let's get started...", isDefault: true},
//     {resellerId: null, route: "policyLookup", section: "resume", value: "If you have a saved claim form that you wish to resume, <a href=\"#/makeaclaim/resume\">click here</a>.", isDefault: true}
//   ];
// }

// const TextManager = class
// {
// 	constructor(resellerId, textItems) {
//   	this._resellerId = resellerId;
//     this._textItems = [...textItems];
//   }
// 	getText(route,section) {
//   	if (!Array.isArray(this._textItems) /*|| this.textItems.length <= 0*/) {
//     	return null;
//     } else {
//     	const textItem = this._textItems.find(e => e.resellerId == this._resellerId && 
//       	e.route == route 
//         && e.section == section)
//       if (textItem) {
//       	return textItem.value;
//       } else {
//       	const defaultItem = this._textItems.find(e => e.isDefault == true 
//         	&& e.route == route 
//           && e.section == section)
//         if (defaultItem) {
//         	return defaultItem.value;
//         } else {
//         	return null;
//         }
//       }
//     }
//   }
// }

// const textManager = new TextManager(1, getTextItems());
// console.log(textManager.getText("home", "leadTitle"));
// console.log(textManager.getText("home", "leadText"));
// console.log(textManager.getText("policyLookup", "title"));
// console.log(textManager.getText("policyLookup", "resume"));

// Load for route then getText has smaller arry to look through!

export function getTextItems() {
    return [
      {resellerId: null, route: "home", section: "leadTitle", value: "Gadget Claims", isDefault: true},
      {resellerId: null, route: "home", section: "leadText", value: "You can make a claim and check on the progress of an existing claim by choosing from the options below.", isDefault: true},
      {resellerId: null, route: "policylookup", section: "title", value: "Let's get started...", isDefault: true},
      {resellerId: null, route: "policydetails", section: "title", value: "Your details...", isDefault: true},
      {resellerId: null, route: "incidenttypes", section: "title", value: "What are you claiming for...", isDefault: true},
      {resellerId: null, route: "aboutYou", section: "title", value: "A couple of questions about you...", isDefault: true},
      {resellerId: null, route: "incidentDetails", section: "title", value: "A couple of questions about the incident...", isDefault: true},
      {resellerId: null, route: "gadgetlist", section: "title", value: "What gadget(s) do you wish to claim for?", isDefault: true},
      {resellerId: null, route: "supportingDocs", section: "title", value: "The following documents help us process your claim...", isDefault: true},
      {resellerId: null, route: "declartion", section: "title", value: "Please make sure you have read and understood the following statements...", isDefault: true},
      {resellerId: null, route: "reviewv2", section: "title", value: "Please check the details that you have provided...", isDefault: true},
      {resellerId: null, route: "thankyou", section: "title", value: "Thank you for submitting your claim", isDefault: true},
      {resellerId: null, route: "contact", section: "title", value: "Contact us...", isDefault: true},
      {resellerId: null, route: "login", section: "title", value: "Please login...", isDefault: true},
      {resellerId: null, route: "resetpassword", section: "title", value: "Reset password...", isDefault: true},
      {resellerId: null, route: "change", section: "title", value: "Change password...", isDefault: true},
      {resellerId: null, route: "resume", section: "title", value: "Saved claim form details", isDefault: true},

      {resellerId: 77, route: "policylookup", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "policydetails", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "incidenttypes", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "aboutYou", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "incidentDetails", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "policylookup", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "gadgetlist", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "gadgetDetails", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "supportingDocs", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "declartion", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "reviewv2", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "thankyou", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "contact", section: "leadTitle", value: "Contact us", sectionClass: "middle-title"},
      {resellerId: 77, route: "contact", section: "title", value: null, sectionClass: null},
      {resellerId: 77, route: "login", section: "leadTitle", value: "Your account", sectionClass: "middle-title"},
      {resellerId: 77, route: "resetpassword", section: "leadTitle", value: "Your account", sectionClass: "middle-title"},
      {resellerId: 77, route: "changepassword", section: "leadTitle", value: "Your account", sectionClass: "middle-title"},
      {resellerId: 77, route: "resume", section: "leadTitle", value: "Make a claim", sectionClass: "middle-title"},
      {resellerId: 77, route: "claimslist", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "viewclaim", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "uploaddocs", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptions", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionslist", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionsinfo", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionsinstructions", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionscancel", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionsbankdetails", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionseditbankdetails", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},
      {resellerId: 77, route: "repairoptionsuploaddocs", section: "leadTitle", value: "Your claims", sectionClass: "middle-title"},

      {resellerId: 999, route: "test", section: "test", value: "test"},
    ];
}

export class TextManager {
	constructor(options) {
    
    // create dict with route as key to improve search?

  	if (options) {
    	this._resellerId = options.resellerId;
      if (options.hasOwnProperty("route") && options.route != null && options.route != undefined ) {
      	this._route = options.route;
      	this._textItems = options.textItems.filter(i => i.route === this._route && (i.resellerId === this._resellerId || i.isDefault === true));
      } else {
      	this._textItems = options.textItems.filter(i => i.resellerId === this._resellerId || i.isDefault === true);
      }
    } else {
    	throw "Options must be provided!";
    }
  }
  getText(section, route) {
    const textItem = this.getTextItem(section, route);
    if (textItem) {
      return textItem.value;
    } else {
      return null;
    }
  }
  getTextItem(section, route) {
        if (!Array.isArray(this._textItems) /*|| this.textItems.length <= 0*/) {
        return null;
      } else {
        if (this.hasOwnProperty("_route") && this._route != null && this._route != undefined ) {
          route = this._route;
        }
        const textItem = this._textItems.find(e => e.resellerId == this._resellerId &&
              e.route == route
          && e.section == section)
        if (textItem) {
              return textItem;
        } else {
              const defaultItem = this._textItems.find(e => e.isDefault == true
              && e.route == route
            && e.section == section)
          if (defaultItem) {
              return defaultItem;
          } else {
              return null;
          }
        }
      }      
  }
  getTextItems(route) {
  	return this._textItems.filter(i => i.route === route);
  }
  getEmpty() {
    return {resellerId: null, route: null, section: null, value: null, sectionClass: null}
  }
}